

import React, { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';


const ScrollUp = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {isVisible && (
        <div className='scroll-up'>
          <div className='scroll-up-btn' onClick={goTop}>
            ⇧
          </div>
        </div>
      )}
    </>
  );
};

export default ScrollUp;
